import { render, staticRenderFns } from "./total-vendor-per-region.vue?vue&type=template&id=08907d0c&scoped=true&"
import script from "./total-vendor-per-region.vue?vue&type=script&lang=js&"
export * from "./total-vendor-per-region.vue?vue&type=script&lang=js&"
import style0 from "./total-vendor-per-region.vue?vue&type=style&index=0&id=08907d0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08907d0c",
  null
  
)

export default component.exports